/**
 * 文案出片「带上产品」(0924 车 B 落地,车 D 合并时拆成独立组件)。
 *
 * 复用通用创建页的 ProductImagePanel(产品库选品 = 产品 main 槽 key;上传 = uploadFrame key
 * 过分类)。**只上送派生出的 productRefKey**(契约 §3.3),产品实体不并进 entities:真人任务的
 * entities 由 applyCharacterPick 独占(api 靠它认真人)。ai 真人 bare 路把 productRefKey 编成
 * role=product 参考、与 identity 同槽。
 *
 * 车 D 追加:当前样片是「手持产品讲解」这类带货模板(`templateWantsProduct`)且还没带产品时,
 * 给一句「带上产品图效果更好」—— 只提示不强制(真人线锁不住产品外形,产品图参考是唯一抓手)。
 */
import type { VideoEntity } from "../../../api/videoService";
import { ProductImagePanel } from "../ProductImagePanel";

export function RealPersonProductPanel({
  entities,
  onChange,
  suggest,
}: {
  entities: VideoEntity[];
  onChange: (next: VideoEntity[], productRefKey: string) => void;
  /** 当前样片建议带产品图(只提示)。 */
  suggest: boolean;
}) {
  return (
    <div className="space-y-1.5" data-testid="real-product-panel">
      <span className="block text-[13.5px] font-semibold text-foreground">
        带上产品
        <span className="ml-1 text-2xs font-normal text-muted-foreground">可选</span>
      </span>
      <p className="text-2xs text-muted-foreground">
        产品会与出镜人同框出现,建议用白底产品图;只取第一件识别为「产品」的图。
      </p>
      {suggest && (
        <p
          data-testid="real-product-suggest"
          className="text-2xs text-amber-600 dark:text-amber-400"
        >
          这条样片是手持产品讲解 —— 带上产品图效果更好(产品外形靠产品图参考锁定),不带也能出片。
        </p>
      )}
      <ProductImagePanel compact entities={entities} onChange={onChange} />
    </div>
  );
}
